import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSON} from '../../platform/functional-fetch-wrapper'
import type {GetSuggestedRepositoriesResponse} from './contracts'

export async function apiGetRepositories(
  memexNumber?: number,
  repositoryId?: number,
): Promise<GetSuggestedRepositoriesResponse> {
  const apiData = getApiMetadata('suggested-repositories-api-data')
  const url = new URL(apiData.url, window.location.origin)
  if (memexNumber != null) {
    url.searchParams.append('memexNumber', `${memexNumber}`)
  }
  if (repositoryId != null) {
    url.searchParams.append('repositoryId', `${repositoryId}`)
  }
  const {data} = await fetchJSON<GetSuggestedRepositoriesResponse>(url)

  return data
}
